import React, { useState, useEffect, useRef, useCallback } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Legend } from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { debounce } from "lodash";
import { Line } from "react-chartjs-2";
import { useToast } from "../../Utils/toastContext";
import {
  svgLogoBase64,
  svgBookBase64,
  svgGraphBase64,
  svgDiagramBase64,
  svgInfoCircleBase64,
} from "../../Constants/config";
import DownloadReportButton from "../../Components/DownloadButton/download-button";
import { useSelector } from "react-redux";
import { selectCardCurrencyName } from "../../Utils/cardCurrency";
import useAccountRestriction from "../../hooks/useAccountRestriction";
import RestrictedAccountAlert from "../../Components/RestrictedAccountAlert/RestrictedAccountAlert";
ChartJS.register(ArcElement, Legend);

const CashAccountInvestmentDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [filter, setFilter] = useState("");
  const cardCurrencyName = useSelector(selectCardCurrencyName);
  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [details, setDetails] = useState(null);
  const [rawData, setRawData] = useState([]);
  const [rawDatahistory, setRawDatahistory] = useState([]);
  const [stockPrices, setStockprices] = useState([]);
  const [factSheetFileName, setfactsheetFileName] = useState("");
  const { showToast } = useToast();
  const { isRestricted, blockIfRestricted } = useAccountRestriction();

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const downloadGraphRef = useRef();
  const [newClientAccountData, setNewClientAccountData] = useState([]);
  const [preSelectedClientAccount, setpreSelectedClientAccount] = useState({});
  const [clientAccountId, setClientAccountId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [clientAccountBalance, setClientAccountBalance] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [chartImage, setChartImage] = useState("");
  const chartRef = useRef(null);
  const [historyChartImage, setHistoryChartImage] = useState("");
  const historyChartRef = useRef(null);
  const [popupDataTable, setPopupDataTable] = useState([]);
  const { from, investment_id } = location.state || {};
  const reportRef = useRef();
  const valuationRef = useRef();

  const [isHiddenReport, setIsHiddenReport] = useState(false); // Initially hidden

  const downloadPDF = useCallback(
    debounce((e) => {
      setIsHidden(true);
    }, 1000), // Debounce time
    [factSheetFileName] // Dependencies
  );
  const pdfOptions = {
    margin: 5,
    filename: "Factsheet-" + factSheetFileName + ".pdf",
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      scale: 2,
      windowWidth: 800,
      backgroundColor: "#ffffff", // Set background to white
      useCORS: true, // Helps with cross-origin images
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    },
  };
  function generateAllocationItems(details) {
    return details.product_allocations
      .map((item) => {
        return `
          <div class="allocation-item">
            <span class="label">${item.product.name}</span>
            <span class="percentage" style="color: #${item.product.color};">
              ${item.allocation}%
            </span>
          </div>
        `;
      })
      .join("");
  }
  function populateTable(data) {
    const tableBody = document.createElement("tbody");

    data.forEach((categoryData) => {
      // Create category row
      const categoryRow = document.createElement("tr");
      if (categoryData.category.name.toUpperCase() == "GROWTH") {
        categoryRow.classList.add("bg-light-blue", "text-bold");
      } else {
        categoryRow.classList.add("bg-light-green", "text-bold");
      }
      categoryRow.innerHTML = `
                  <td colspan="1"></td>
            <td colspan="1">${categoryData.category.name.toUpperCase()}</td>
                              <td colspan="1"></td>
                  <td colspan="1"></td>
                  <td colspan="1"></td>
    <td colspan="1" class=""></td>
                <td colspan="1" class=""></td>
                                  <td colspan="1"></td>
                  <td colspan="1"></td>
                                    <td colspan="1"></td>
                                                                        <td colspan="1"></td>



        `;
      tableBody.appendChild(categoryRow);

      // Loop through each product in the category
      categoryData.category.products.forEach((product, productIndex) => {
        const productRow = document.createElement("tr");
        if (categoryData.category.name.toUpperCase() == "GROWTH") {
          productRow.classList.add("bg-product-blue", "text-product");
        } else {
          productRow.classList.add("bg-product-green", "text-product");
        }
        productRow.innerHTML = `
                <td>${(productIndex + 1).toString().padStart(2, "0")}</td>
                <td>${product.name}</td>
                <td></td>
                <td>${product.allocation
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                <td>${
                  product.capital
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                }</td>
                <td class=""></td>
                <td class=""></td>
                <td></td>
                                <td></td>
                                                <td class=""></td>
                                                                                                <td class=""></td>



            `;
        tableBody.appendChild(productRow);

        // Loop through each stock in the product
        product.stocks.forEach((stock) => {
          const stockRow = document.createElement("tr");
          if (categoryData.category.name.toUpperCase() == "GROWTH") {
            stockRow.classList.add("bg-stock-blue");
          } else {
            stockRow.classList.add("bg-stock-green");
          }
          stockRow.innerHTML = `
                    <td></td>
                    <td>${stock.name}</td>
                    <td>${stock.asx_code}</td>
                    <td class="">${stock.allocation.toFixed(2)}%
                    ${!stock.allocation ? "-" : ""}</td>
                    <td class="">${
                      stock.capital
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${
                      stock.market_value
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${
                      !stock.quantity
                        ? "00"
                        : stock.quantity
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</td>
                                                 <td class="text-right">${
                                                   stock.market_value
                                                     .toFixed(2)
                                                     .toString()
                                                     .replace(
                                                       /\B(?=(\d{3})+(?!\d))/g,
                                                       ","
                                                     ) || "-"
                                                 }</td>
                    <td class="text-right">${
                      !stock.brokerage_fee
                        ? "-"
                        : stock.brokerage_fee.toFixed(2)
                    }</td>
                                    <td class=""></td>
                                                                                    <td class=""></td>


                `;
          tableBody.appendChild(stockRow);
        });
      });
      const subTotalRow = document.createElement("tr");
      if (categoryData.category.name.toUpperCase() == "GROWTH") {
        subTotalRow.classList.add("bg-light-blue", "text-bold");
      } else {
        subTotalRow.classList.add("bg-light-green", "text-bold");
      }
      subTotalRow.innerHTML = `
                    <td class=""></td>
              <td colspan="2">SUB-TOTAL ${categoryData.category.name}</td>
              <td>${categoryData.category.allocation.toFixed(2)}%</td>
              <td>${
                categoryData.category.capital
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
              }</td>
              <td class=""></td>
              <td class=""></td>
              <td class="text-right">${
                categoryData.category.market_value
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
              }</td>
                                                <td class=""></td>
                                                                <td class=""></td>
                                                <td class=""></td>


          `;
      tableBody.appendChild(subTotalRow);
    });
    const summaryHeadingRow = document.createElement("tr");
    summaryHeadingRow.classList.add("bg-summary", "text-bold");
    summaryHeadingRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">Summary</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                                  <td class=""></td>
                                                <td class=""></td>


        `;
    tableBody.appendChild(summaryHeadingRow);
    const summaryGrowthRow = document.createElement("tr");
    summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
    summaryGrowthRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">${data[0].category.name}</td>
                    <td class="">${data[0].category.allocation.toFixed(2)}%</td>
                  <td class="">${
                    data[0].category.capital
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    data[0].category.market_value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    data[0].category.category_brokerage_fee || "-"
                  }</td>
                                  <td class=""></td>
                                                <td class=""></td>


        `;
    tableBody.appendChild(summaryGrowthRow);
    const summaryDefensiveRow = document.createElement("tr");
    summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
    summaryDefensiveRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">${data[1].category.name}</td>
                    <td class="">${data[1].category.allocation.toFixed(2)}%</td>
                  <td class="">${
                    data[1].category.capital
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    data[1].category.market_value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    data[1].category.category_brokerage_fee || "-"
                  }</td>
                                  <td class=""></td>
                                                                                  <td class=""></td>



        `;
    tableBody.appendChild(summaryDefensiveRow);
    const summaryTotalRow = document.createElement("tr");
    summaryTotalRow.classList.add("bg-summary", "text-bold");
    summaryTotalRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">TOTAL PORTFOLIO</td>
                    <td class="">${
                      (
                        data[0].category.allocation +
                        data[1].category.allocation
                      ).toFixed(2) + "%" || "-"
                    }</td>
                  <td class="">${
                    (data[0].category.capital + data[1].category.capital)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    (
                      data[0].category.market_value +
                      data[1].category.market_value
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    (
                      data[0].category.category_brokerage_fee +
                      data[1].category.category_brokerage_fee
                    ).toFixed(2) || "-"
                  }</td>
                                  <td class=""></td>
                                  <td class=""></td>


        `;
    tableBody.appendChild(summaryTotalRow);
    // Optional page break for large content
    const pageBreakRow = document.createElement("tr");
    pageBreakRow.classList.add("page-break");
    pageBreakRow.innerHTML = "<td colspan='11'></td>";
    tableBody.appendChild(pageBreakRow);
    return tableBody;
  }
  const handleDownloadPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(details);

    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
        @page {
  size: A4 portrait;
  margin: 0;
}
  html, body {
          margin: 0;
          padding: 0;
                    font-family:sans-serif;
  overflow: auto;  /* Ensure content can overflow */

          height: 100%; /* Ensure the body fills the entire height */
        }        .pdf-container {
            max-width: 100% !important;
            margin: 20px;
          }
          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
  
          .custom-header {
            position: relative;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            padding-top: 10px; /* Ensures no padding at the top */
          }
  
          .logo-container {
            display: flex;
            align-items: center;
          }
  
          .logo {
            width: 96px; /* Tailwind w-24 = 6rem = 96px */
            max-width: 150px;
            height: auto;
            object-fit: contain;
            margin-right: 1rem;
          }
  
          .title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.125rem; /* Tailwind text-lg */
            font-weight: 500;    /* Tailwind font-medium */
            padding: 0;          /* Remove any padding */
            margin: 0;           /* Remove any margin */
          }
  
          .date {
            font-size: 0.875rem;  /* Tailwind text-sm */
            font-weight: 500;
            color: #000000;
            padding-bottom: 16px;
          }
                  .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }
        .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}

      .content {
        display: flex;
        gap: 20px;
        margin-top: 8px;
        padding-right: 16px;
      }

      .left-column {
        width: 40%;
        padding-right: 16px;
        border-right: 1px solid black;
      }

      .right-column {
        width: 60%;
        padding-left: 10px;
         padding-left: 10px;
      }

      .info-block {
        margin-bottom: 24px;
      }

      .label {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin: 0;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }

      .section-title {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .description {
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        line-height: 1.6;
      }
              .form-container {
        background-color: #ffffff;
        border: 1px solid #000000;
        border-radius: 6px;
        margin-top: 20px;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-collapse: collapse;
      }

      .cell {
        border-bottom: 1px solid #000000;
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
  .cell-last {
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
      .cell:nth-child(4n) {
        border-right: none;
      }
  .cell-last:nth-child(4n) {
        border-right: none;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      .allocation-container {
        border: 1px solid black;
        border-radius: 8px;
        padding: 16px;
        margin-top: 20px;
      }

      .allocation-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        padding-bottom: 8px;
        margin-bottom: 16px;
      }

      .allocation-header img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .allocation-header h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }

      .allocation-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      .allocation-details {
        flex: 1 1 50%;
      }

      .allocation-items {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 12px;
      }

      .allocation-item {
        display: flex;
        flex-direction: column;
        word-break: break-word;
      }

      .allocation-item .product-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }

      .allocation-item .percentage {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .chart-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
      }

      .chart-container img {
        width: 160px;
        height: 160px;
      }
.page-break {
         page-break-before: always;
  break-before: page;
  display: block;
  height: 0; /* No extra space */
  width: 100%;
  content: "";}
      /* Responsive fallback (1 column on small screens) */
      @media print {
        .grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }
        </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">Factsheet</h2>
          <div class="date">${date}</div>
        </div>
                  <div class="header">
      <!-- Title Section with Icon -->
      <div class="title-section">
        <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
          <h2 class="second-title">Caprock Model Portfolio - ${
            details.basic_details.name
          }</h2>
      </div>
    </div>

    <!-- Content Section -->
    <div class="content">
      <!-- Left Column -->
      <div class="left-column">
        <div class="info-block">
          <p class="label">Strategy</p>
          <p class="value">Caprock Model Portfolio - ${
            details.basic_details.name
          }</p>
        </div>
        <div class="info-block">
          <p class="label">Type</p>
          <p class="value">${details.basic_details.strategy_type}</p>
        </div>
        <div class="info-block">
          <p class="label">Growth</p>
          <p class="value">${details.basic_details.growth_percentage}</p>
        </div>
        <div class="info-block">
          <p class="label">Defensive</p>
          <p class="value">${details.basic_details.defensice_percentage}</p>
        </div>
      </div>

      <!-- Right Column -->
      <div class="right-column">
              <div class="info-block">

        <p class="label">FUND OBJECTIVE & PROCESS</p>
        <p class="description">
${details.basic_details.fund_objective_and_process}        </div>
      </p>
      </div>
    </div>
        <div class="form-container">
      <div class="grid">
        <!-- Cell -->
        <div class="cell">
          <div class="label">Platform</div>
          <div class="value">${details.details.platform.name}</div>
        </div>
        <div class="cell">
          <div class="label">Code</div>
          <div class="value">${details.details.code}</div>
        </div>
        <div class="cell">
          <div class="label">Min investment</div>
          <div class="value">
          $${details.details.minimum_investment
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
        </div>
        <div class="cell">
          <div class="label">Investment Manager</div>
          <div class="value">${details.details.investment_manager.name}</div>
        </div>

        <div class="cell">
          <div class="label">Sub Advisor</div>
          <div class="value">${
            details.details.sub_advisor ? details.details.sub_advisor.name : ""
          }</div>
        </div>
        <div class="cell">
          <div class="label">Risk profile</div>
          <div class="value">${details.details.risk_profile}</div>
        </div>
        <div class="cell">
          <div class="label">Risk rating</div>
          <div class="value">${details.details.risk_rating}</div>
        </div>
        <div class="cell">
          <div class="label">Strategy inception date</div>
          <div class="value">${formatDateList(
            details.details.strategy_date_creation
          )}</div>
        </div>

        <div class="cell-last">
          <div class="label">Investments</div>
          <div class="value">${details.details.investment_tags.join(", ")}
</div>
        </div>
        <div class="cell-last">
          <div class="label">SMA Fees</div>
          <div class="value">${details.details.sma_fee} (+ GST)</div>
        </div>
        <div class="cell-last">
          <div class="label">Investment Manager Fees</div>
          <div class="value">${
            details.details.investment_manager_fee
          }% + GST</div>
        </div>
        <div class="cell-last" style="border-right: none;">
          <div class="label">Sub Advisor Fees</div>
          <div class="value">${details.details.sub_advisor_fee}% + GST</div>
        </div>
      </div>
    </div>
        <div class="allocation-container">
      <div class="allocation-header">
        <img src="${svgGraphBase64}" alt="Icon" />
        <h3>Current Target Allocation</h3>
      </div>

      <div class="allocation-grid">
        <div class="allocation-details">
          <div class="allocation-items" id="allocation-items">
               ${allocationItemsHTML}
          </div>
        </div>

        <div class="chart-container">
          <img src="${chartImage}" alt="Doughnut Chart" />
        </div>
      </div>
    </div>
    </div>
    
                    <div class="page-break"></div>
     <div class="pdf-container">

<div style="background-color: #ffffff; margin-bottom: 1rem; padding: 0.5rem; border-radius: 6px;">
  
  <!-- Header -->
  <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; width: 100%; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
    <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
      <img src="${svgDiagramBase64}" alt="Portfolio Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
      <span>Historical Performance</span>
    </h3>
    <div style="display: flex; align-items: center; gap: 0.2rem; font-size: 0.875rem; margin-bottom: 0.5rem;">
      <span style="color: #555; white-space: nowrap;">Caprock Growth:</span>
      <span style="font-weight: 500; color: #000; white-space: nowrap;">${
        details.details.risk_profile
      }</span>
    </div>
  </div>

  <!-- Chart -->
  <div style="margin-top: 0.5rem;">
    <img src="${historyChartImage}" alt="history Chart" style="width: 100%; max-height: 200px; object-fit: contain;" />
  </div>

  <!-- Note -->
  <div style="font-size: 0.875rem; color: #000; line-height: 1.6; margin-top: 1rem;">
    <p style="font-weight: bold; margin-bottom: 0.25rem;">
      *Past performance is not a guide to future performance.
    </p>
    <p style="font-weight: 500;">
                          ${details.historic_performance_notes}
    </p>
  </div>

  <!-- Disclaimer -->
  <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
    <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
      <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
      <span>Disclaimer</span>
    </h3>
    <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
      ${details.disclaimer}
    </p>
  </div>

  <!-- Copyright -->
  <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
    <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
      <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
      <span>Copyright</span>
    </h3>
    <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
    ${details.copy_rights}
    </p>
  </div>
</div>
      </div> 

           </body>
    </html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Factsheet-Caprock Model Portfolio - ${factSheetFileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  const handleDownloadValuationPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(details);
    const tableBodyElement = populateTable(popupDataTable);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
                @page {
  size: A4 landscape;
  margin: 0;
}
  html, body {
          margin: 0;
          padding: 0;
                    font-family:sans-serif;
  overflow: auto;  /* Ensure content can overflow */

          height: 100%; /* Ensure the body fills the entire height */
        }        .pdf-container {
            max-width: 100% !important;
            margin: 20px;
          }
          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
  
          .custom-header {
            position: relative;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            padding-top: 10px; /* Ensures no padding at the top */
          }
  
          .logo-container {
            display: flex;
            align-items: center;
          }
  
          .logo {
            width: 96px; /* Tailwind w-24 = 6rem = 96px */
            max-width: 150px;
            height: auto;
            object-fit: contain;
            margin-right: 1rem;
          }
  
          .title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.125rem; /* Tailwind text-lg */
            font-weight: 500;    /* Tailwind font-medium */
            padding: 0;          /* Remove any padding */
            margin: 0;           /* Remove any margin */
          }
  
          .date {
            font-size: 0.875rem;  /* Tailwind text-sm */
            font-weight: 500;
            color: #000000;
            padding-bottom: 16px;
          }
                  .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }

         .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
      .label {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin: 0;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }

      .section-title {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .description {
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        line-height: 1.6;
      }
              .form-container {
        background-color: #ffffff;
        border: 1px solid #000000;
        border-radius: 6px;
        margin-top: 0px;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-collapse: collapse;
      }

      .cell {
        border-bottom: 1px solid #000000;
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
  .cell-last {
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
      .cell:nth-child(4n) {
        border-right: none;
      }
  .cell-last:nth-child(4n) {
        border-right: none;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      .allocation-container {
        border: 1px solid black;
        border-radius: 8px;
        padding: 16px;
        margin-top: 20px;
      }

      .allocation-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        padding-bottom: 8px;
        margin-bottom: 16px;
      }

      .allocation-header img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .allocation-header h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }

      .allocation-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      .allocation-details {
        flex: 1 1 50%;
      }

      .allocation-items {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 12px;
      }

      .allocation-item {
        display: flex;
        flex-direction: column;
        word-break: break-word;
      }

      .allocation-item .product-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }

      .allocation-item .percentage {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .chart-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
      }

      .chart-container img {
        width: 160px;
        height: 160px;
      }
.page-break {
         page-break-before: always;
  break-before: page;
  display: block;
  height: 0; /* No extra space */
  width: 100%;
  content: "";}
      /* Responsive fallback (1 column on small screens) */
      @media print {
        .grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }
            table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      margin-top: 1rem;
    }

    th, td {
      border: 1px solid #ffffff;
      padding: 0.5rem 1rem;
    }

    /* Header row styling */
    th {
      background-color: #6AA7D3;
      color: white;
      font-weight: bold;
    }

    /* Specific styles for 'Market Price' column header */
    .market-price {
      background-color: #F4D580;
    }

    /* Optional styling for overflow if required */
    .overflow-x-auto {
      overflow-x: auto;
    }
              .bg-light-blue {
            background-color: #92C5EA;
        }
         .bg-product-blue {
            background-color: #C6DFF1;
        }
                .bg-stock-blue {
            background-color: #E6F3FC;
        }
            .bg-summary{
                        background-color: #EAEAEA;

            }
             .bg-product-green {
            background-color: #C0E2C1;
        }
             .bg-stock-green {
            background-color: #E7F5E8;
        }

        .bg-light-green {
            background-color: #A9D4AB;
        }

        .bg-light-red {
            background-color: #F8C5C5;
        }

        .bg-yellow {
            background-color: #F4D580;
        }

        .bg-off-white {
            background-color: #EAEAEA;
        }

        .text-bold {
            font-weight: bold;
        }
        .text-product{
                    font-weight: bold;
color: #005A9C;
        }

        .text-center {
            text-align: center;
        }

        .text-right {
            text-align: right;
        }

        .font-small {
            font-size: 12px;
        }

        .page-break {
            page-break-before: always;
        }
        </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">Holding Valuation Report</h2>
          <div class="date">${date}</div>
        </div>
                  <div class="header">
      <!-- Title Section with Icon -->
      <div class="title-section">
        <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
          <h2 class="second-title">Caprock Model Portfolio - ${
            details.basic_details.name
          }</h2>
      </div>
    </div>
        <div class="form-container">
      <div class="grid">
        <!-- Cell -->
        <div class="cell">
          <div class="label">Client Id</div>
          <div class="value">CM0012954P</div>
        </div>
        <div class="cell">
          <div class="label"> Broker Id</div>
          <div class="value">CM0012954P</div>
        </div>
        <div class="cell">
          <div class="label">Hin</div>
          <div class="value">
          113827238</div>
        </div>
        <div class="cell">
          <div class="label">Risk profile</div>
          <div class="value">${details.details.risk_profile}
</div>
        </div>

        <div class="cell-last">
          <div class="label">Type</div>
          <div class="value">${details.basic_details.strategy_type}</div>
        </div>
        <div class="cell-last">
          <div class="label">Strategy inception date</div>
          <div class="value">${formatDateList(
            details.details.strategy_date_creation
          )}</div>
        </div>
        <div class="cell-last">
          <div class="label">Growth</div>
          <div class="value">${details.basic_details.growth_percentage}</div>
        </div>
        <div class="cell-last">
          <div class="label">Defensive</div>
          <div class="value">${details.basic_details.defensice_percentage}</div>
        </div>
        </div>
      </div>
        <div class="allocation-container">
      <div class="allocation-header">
        <img src="${svgGraphBase64}" alt="Icon" />
        <h3>Current Target Allocation</h3>
      </div>

      <div class="allocation-grid">
        <div class="allocation-details">
          <div class="allocation-items" id="allocation-items">
               ${allocationItemsHTML}
          </div>
        </div>

        <div class="chart-container">
          <img src="${chartImage}" alt="Doughnut Chart" />
        </div>
      </div>
    </div>
    
  <div class="overflow-x-auto">
    <table>
      <thead>
        <tr>
          <th>No</th>
          <th>Strategic Asset Allocation</th>
          <th>Code</th>
          <th>Holdings</th>
          <th>Cost Base</th>
          <th>Value($)</th>
          <th>Weight(%)</th>
          <th>Market Price</th>
          <th>Value ($)</th>
          <th>P/L</th>
                    <th>Weight(%)</th>
        </tr>
      </thead>
                    ${tableBody}


    </table>
  </div>
    </div>

           </body>
    </html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Holding Valuation-${factSheetFileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenReport(false);
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      const response = await fetch(
        `${BASE_URL}/v1/investment-portfolio/factsheet/${investment_id}/export/excel`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcel = async () => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReport();
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Factsheet - Caprock Model Portfolio - ${factSheetFileName}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };
  const handleContinue = () => {
    setLoading(true);
    downloadPDF();
  };
  useEffect(() => {
    if (isHidden == true) {
      if (isHidden == true) {
        handleDownloadPDF();
      }
    }
  }, [isHidden]);
  // Download valuation report
  const downloadValuationReport = useCallback(
    debounce((e) => {
      setIsHiddenReport(true);
    }, 1000), // Debounce time
    [factSheetFileName] // Dependencies
  );
  useEffect(() => {
    if (isHiddenReport == true) {
      handleDownloadValuationPDF();
    }
  }, [isHiddenReport]);
  // End here
  const formatNumber = (value) => {
    if (!value) return "";

    // Remove commas before parsing
    const number = parseFloat(value.toString().replace(/,/g, ""));

    if (isNaN(number)) return "";

    // Format with 2 decimal places and add commas
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleAmountChange = (e, values) => {
    // // Remove any non-numeric characters except the comma
    // const value = event.target.value.replace(/[^\d]/g, "");

    // // Format the value as currency
    // const formattedValue = new Intl.NumberFormat().format(value);

    // // Set the formatted value
    // setAmount(formattedValue);
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setAmount(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
  const handleSelectClientAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setClientAccountId(selectedOption.value);
    setClientAccountBalance(selectedOption.balance);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        downloadGraphRef.current &&
        !downloadGraphRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getDetails = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/investment-hub/portfolio/${investment_id}`
      );
      if (response.status == 200) {
        setDetails(response.data);
        setfactsheetFileName(response.data.basic_details.name);
        setRawData(response.data.product_allocations);
        setUserId(response.data.invest_application.user_id);
        setRawDatahistory(response.data.performance_graph.data);
        const stockPrices = response.data.performance_graph.data.map(
          (item) => item.value
        );
        setStockprices(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  useEffect(() => {
    getDetails();
    getWalletAccountsByClient();
  }, [investment_id, cardCurrencyName]);
  const dataset = {
    labels: rawData.map((item) => item.product.name), // Extract names
    datasets: [
      {
        data: rawData.map((item) => parseFloat(item.allocation)), // Convert allocation to numbers
        backgroundColor: rawData.map((item) => `#${item.product.color}`), // Ensure # prefix
        hoverBackgroundColor: rawData.map((item) => `#${item.product.color}`), // Same for hover
        borderWidth: 1,
      },
    ],
  };
  useEffect(() => {
    if (chartRef.current && dataset?.datasets?.length > 0) {
      setTimeout(() => {
        const chartInstance = chartRef.current;
        if (chartInstance?.toBase64Image) {
          setChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures the chart fully renders before conversion
    }
  }, [dataset]);

  const plugin = {
    id: "customCanvasBackgroundImage",
    beforeDraw: (chart) => {
      const { ctx, chartArea, data } = chart;
      const { top, bottom, left, right, width, height } = chartArea;
      const centerX = left + width / 2;
      const centerY = top + height / 2;

      const radius = Math.min(width, height) / 2; // Radius of the donut
      const fontSize = 12;

      ctx.save();
      ctx.font = `${fontSize}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw percentages and lines for each section
      const meta = chart.getDatasetMeta(0); // First dataset
      meta.data.forEach((arc, index) => {
        const angle = (arc.startAngle + arc.endAngle) / 2; // Middle angle of the segment
        const x = centerX + Math.cos(angle) * (radius / 1.8); // Adjust for inner placement of text
        const y = centerY + Math.sin(angle) * (radius / 1.8);
        const percentage = `${data.datasets[0].data[index].toFixed(1)}%`;

        // Get the color for this section
        const sectionColor = data.datasets[0].backgroundColor[index];

        // Calculate the position of the text with space between the center and the donut
        const textX = centerX + Math.cos(angle) * (radius / 2.5); // Pushing text further out
        const textY = centerY + Math.sin(angle) * (radius / 2.5);

        // Draw line pointing from text to the donut center
        ctx.beginPath();
        ctx.moveTo(x, y); // Starting point is the position of the percentage text
        ctx.lineTo(
          centerX + Math.cos(angle) * (radius / 1),
          centerY + Math.sin(angle) * (radius / 1)
        ); // Ending at the center of the donut
        ctx.strokeStyle = sectionColor; // Set line color to section's color
        ctx.lineWidth = 1; // Line width
        ctx.stroke();

        // Draw percentage text
        ctx.fillStyle = sectionColor; // Set text color to section's color
        ctx.fillText(percentage, textX, textY);
      });

      ctx.restore();
    },
  };

  const options = {
    cutout: "70%", // Creates the donut hole
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  const data = {
    accountBalance: {
      title: "Account Balance",
      date: "Nov, 2023",
      activeAccounts: "8",
      activePercent: "80%",
      portfolio: "$827,234,289.60",
      graphData: [
        { month: "Jan", value: 20 },
        { month: "Feb", value: 80 },
        { month: "Mar", value: 60 },
        { month: "Apr", value: 90 },
        { month: "May", value: 90 },
        { month: "Jun", value: 90 },
        { month: "Jul", value: 20 },
        { month: "Aug", value: 30 },
        { month: "Sep", value: 50 },
        { month: "Oct", value: 30 },
        { month: "Nov", value: 20 },
        { month: "Dec", value: 50 },
      ],
    },
    totalDeposit: {
      title: "Total Deposit",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
    totalWithdrawal: {
      title: "Total Withdrawal",
      date: "Nov, 2023",
      currentAmount: "$827,234,289.60",
      previousAmount: "$0.00",
      previousDate: "Aug, 2023",
    },
  };
  const getWalletAccountsByClient = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/cash-accounts?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
            balance: profile.balance,
          });
        });
        setNewClientAccountData(AccountData);
        setpreSelectedClientAccount(AccountData[0]);
        handleSelectClientAccount(AccountData[0]);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setNewClientAccountData([]);
          setpreSelectedClientAccount({});
          handleSelectClientAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const createInvestment = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/investment-hub/portfolio/investment-request`;
    const bodyData = {
      user_id: userId,
      cash_account_id: clientAccountId,
      amount: Number(amount),
      investment_portfolio_id: investment_id,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleCreateInvestment = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      if (blockIfRestricted()) {
        setLoading(false);
        return;
      }
      let toastMessage = null;
      try {
        const response = await createInvestment();
        if (response.status == 200) {
          let redirectState = {
            path: "/investment-hub",
            state: {
              from: location.pathname,
              historyStack: [
                ...(location.state?.historyStack || []),
                location.pathname,
              ],
            },
          };
          sessionStorage.setItem(
            "redirectAfterLogin",
            JSON.stringify(redirectState)
          );
          navigate("/investment-hub");
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, clientAccountId, amount, investment_id, blockIfRestricted] // Dependencies
  );
  const labelsLine =
    rawDatahistory.length > 0
      ? rawDatahistory.map((item) => {
          const date = new Date(item.date); // Parse the date
          return date; // Return Date object (Chart.js can parse Date objects)
        })
      : [];
  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor: "#005A9C",
        // backgroundColor: (context) => {
        //   const chart = context.chart;
        //   const { ctx, chartArea } = chart;

        //   if (!chartArea) {
        //     return null; // Wait until the chart is fully rendered
        //   }

        //   const gradient = ctx.createLinearGradient(
        //     0,
        //     chartArea.top,
        //     0,
        //     chartArea.bottom
        //   );
        //   gradient.addColorStop(0, "rgba(74, 144, 226, 0.1)"); // Light blue at the top
        //   gradient.addColorStop(1, "white"); // White at the bottom

        //   return gradient;
        // },
        tension: 0.4,
        fill: false,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };
  useEffect(() => {
    if (historyChartRef.current && dataLine?.datasets?.[0]?.data?.length > 0) {
      setTimeout(() => {
        const chartInstance = historyChartRef.current;
        if (chartInstance?.toBase64Image) {
          setHistoryChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures chart is fully rendered
    }
  }, [dataLine]);
  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        backgroundColor: "black",
        borderColor: "#4A90E2",
        borderWidth: 1,
        titleColor: "#8DAAE8",
        bodyColor: "white",
        displayColors: false,
        callbacks: {
          title: (tooltipItems) => {
            // Format the title as MM/YYYY
            // const date = new Date(tooltipItems[0].label);
            // const month = String(date.getMonth() + 1).padStart(2, "0");
            // const year = date.getFullYear();
            // return `${month}/${year}`;
            const match = tooltipItems[0].label.match(/(\w+) (\d+), (\d+)/);
            if (!match) return "Invalid Date";

            const [, monthStr, day, year] = match;

            // Convert month name to number
            const monthNames = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            const month = monthNames.indexOf(monthStr) + 1; // Convert to 1-based index

            return `  ${month.toString().padStart(2, "0")}/${year}  `;
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `  $${tooltipItem.raw.toFixed(2)}  `;
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        type: "time", // Ensure the x-axis uses time scale
        time: {
          unit: "month", // Display months
        },
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          display: true,
          color: "black",

          callback: function (value) {
            const date = new Date(value); // Parse the timestamp as a date
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return [month, year]; // Display month and year on separate lines
          },
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60; // Adjust the height to ensure space for two lines
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // Show grid lines on the chart area
          drawTicks: false, // Optionally hide ticks on grid lines
          color: "rgba(0, 0, 0, 0.1)", // Set the color of the grid lines (light gray)
          lineWidth: 1, // Set the line width of the grid lines
        },
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10, // Add spacing for Y-axis labels
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        offset: true, // Add extra space between the border and the graph
        border: { display: false },
      },
    },
  };
  return (
    <div className="pt-4 p-2 lg:min-w-[78vw] lg:max-w-[80vw]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="pt-4  text-xs overflow-x-auto  flex-wrap items-center">
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter("")}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            Details
          </button>
          <button
            onClick={() => setFilter("invest")}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "invest"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Invest Now
          </button>
        </div>
      </div>
      {isLoading || !details ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div>
          {filter == "" && (
            <div>
              <div className="p-4 bg-white rounded-lg shadow-lg">
                {/* Header Section */}
                <div className="flex justify-between items-start flex-wrap">
                  {/* Title Section with Icon */}
                  <div className="flex items-center space-x-3 mb-4 sm:mb-0">
                    <img
                      src="/book.svg"
                      alt="Portfolio Icon"
                      className="w-6 h-6"
                    />
                    <div>
                      <h2 className="text-xl font-bold">
                        Caprock Model Portfolio - {details.basic_details.name}
                      </h2>
                    </div>
                  </div>

                  {/* Status Section with Icon */}
                  <div className="flex items-center space-x-2">
                    <span className="text-sm text-[#A6A6A6] font-medium">
                      Status:{" "}
                    </span>
                    <span className="text-sm text-black font-medium">
                      Active
                    </span>
                    <img
                      src="/green-active.svg"
                      alt="Status Icon"
                      className="w-4 h-4"
                    />
                  </div>
                </div>

                {/* Content Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-10 gap-6 mt-6">
                  {/* Left Column (40%) */}
                  <div className="col-span-1 sm:col-span-1 lg:col-span-4 space-y-8 pr-4 border-r-0 lg:border-r border-gray-300">
                    <div>
                      <p className="text-xs text-[#A6A6A6] font-medium">
                        Strategy
                      </p>
                      <p className="text-sm font-medium">
                        Caprock Model Portfolio - {details.basic_details.name}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] font-medium">Type</p>
                      <p className="text-sm font-medium">
                        {details.basic_details.strategy_type}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] font-medium">
                        Growth
                      </p>
                      <p className="text-sm font-medium">
                        {details.basic_details.growth_percentage}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] font-medium">
                        Defensive
                      </p>
                      <p className="text-sm font-medium">
                        {details.basic_details.defensice_percentage}
                      </p>
                    </div>
                  </div>

                  {/* Right Column (60%) */}
                  <div className="col-span-1 sm:col-span-1 lg:col-span-6">
                    <p className="text-xs text-[#A6A6A6] font-medium mb-1">
                      FUND OBJECTIVE & PROCESS
                    </p>
                    <p className="text-sm text-black font-medium leading-relaxed">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            details.basic_details.fund_objective_and_process,
                        }}
                        className="text-sm"
                      ></div>
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white  mt-4 rounded-lg  shadow-lg">
                {/* Form Fields */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
                  {/* Name */}
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Platform
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.platform.name}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Code
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {" "}
                        {details.details.code}
                      </p>
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Min investment
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        $
                        {details.details.minimum_investment
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </p>
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                    <label className="text-xs font-medium text-labelLightColour">
                      Investment Manager
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.investment_manager.name}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Sub-advisor
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.sub_advisor
                          ? details.details.sub_advisor.name
                          : ""}
                      </p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Risk profile
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.risk_profile}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Risk rating
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.risk_rating}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                    <label className="text-xs font-medium text-labelLightColour">
                      Strategy inception date
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {formatDateList(details.details.strategy_date_creation)}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Investments
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.investment_tags.join(", ")}{" "}
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      SMA Fees
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.sma_fee}% (+ GST)
                      </p>
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-xs font-medium text-labelLightColour">
                      Investment Manager Fees
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.investment_manager_fee}% + GST
                      </p>
                    </div>
                  </div>
                  <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                    <label className="text-xs font-medium text-labelLightColour">
                      Sub Advisor Fees
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.details.sub_advisor_fee}% + GST
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-4 lg:flex mb-4 lg:space-x-4 gap-4">
                {/* Left Section: Two Cards */}
                <div className="flex flex-col flex-[1.5] space-y-4">
                  <div className="bg-white pt-4 pl-4 pr-4 rounded-lg shadow-md w-full flex-1">
                    <div className="flex justify-between border-b  items-start">
                      <div className="flex items-center pb-2 space-x-4">
                        <img
                          src="/presention-chart.svg"
                          alt="Account Icon"
                          className="w-5 h-5 rounded-full"
                        />
                        <h3 className="text-black text-lg font-medium">
                          Current Target Allocation
                        </h3>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                      {details.product_allocations.map((item, index) => (
                        <div
                          key={index}
                          className="col-span-1 pt-4 pl-4 pb-4 border-b "
                        >
                          <label className="text-xs font-medium text-labelLightColour">
                            {item.product.name}
                          </label>
                          <p className="text-black text-sm font-medium">
                            {item.allocation}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-white pt-4 pl-4 pr-4 rounded-lg shadow-md w-full flex-1">
                    <div className="flex justify-between border-b  items-start">
                      <div className="flex items-center pb-2 space-x-4">
                        <img
                          src="/activity.svg"
                          alt="Account Icon"
                          className="w-5 h-5 rounded-full"
                        />
                        <h3 className="text-black text-lg font-medium">
                          Risk Profile
                        </h3>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                      {/* Name */}
                      <div className="col-span-1 pt-4 pl-4 pb-4 border-b md:border-r">
                        <label className="text-xs font-medium text-labelLightColour">
                          Growth
                        </label>
                        <p className="text-black text-sm font-medium">
                          {details.risk_profile[0].allocation}%
                        </p>
                      </div>

                      {/* Email */}
                      <div className="col-span-1 pt-4 pl-4 pb-4 border-b">
                        <label className="text-xs font-medium text-labelLightColour">
                          Defensive
                        </label>
                        <p className="text-black text-sm font-medium">
                          {details.risk_profile[1].allocation}%
                        </p>
                      </div>

                      {/* Mobile Number */}
                      <div className="col-span-1 pt-4 pl-4 pb-4  md:border-r">
                        <label className="text-xs font-medium text-labelLightColour">
                          Total
                        </label>
                        <p className="text-black text-sm font-medium">
                          {details.risk_profile[2].allocation}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Section: Account Balance */}
                <div className="bg-white p-6 rounded-lg lg:mt-0 md:mt-0 mt-4 shadow-lg lg:flex-[2.5] border border-gray-200">
                  {/* Top Heading */}
                  <div className="flex items-center border-b pb-2 mb-6">
                    {/* Icon Image */}
                    <img
                      src="/graph.svg" // Replace with your icon path
                      alt="Icon"
                      className="w-6 h-6 mr-2"
                    />
                    {/* Heading */}
                    <h3 className="text-lg font-medium text-black">
                      Caprock Model Portfolio - {details.basic_details.name}{" "}
                      Visualization
                    </h3>
                  </div>

                  <div className="lg:flex">
                    {/* Left Column: Allocation Details */}
                    <div className="flex-[1] space-y-4 pr-6  border-gray-200">
                      <div className="text-sm space-y-8">
                        {details.product_allocations.map((item, index) => (
                          <div className="flex flex-col items-start">
                            <p className="text-labelLightColour font-medium">
                              {item.product.name}
                            </p>
                            <p
                              className="font-medium"
                              style={{ color: `#${item.product.color}` }}
                            >
                              {item.allocation}%
                            </p>{" "}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Right Column: Doughnut Chart */}
                    <div className="flex-[2] flex flex-col items-center space-y-4 pl-8">
                      <div className="w-60 h-60">
                        <Doughnut
                          ref={chartRef}
                          data={dataset}
                          options={options}
                          // plugins={[plugin]} // Ensures percentages are displayed in the donut center
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white mt-4 mb-4 p-6 px-8 shadow-md rounded-md">
                {/* Header with Download Dropdown */}
                <div className="flex justify-between items-center w-full">
                  <h3 className="text-md font-medium text-black flex items-center">
                    <span className="mr-2">
                      <img
                        src="/diagram.svg"
                        alt="Portfolio Icon"
                        className="w-5 h-5"
                      />
                    </span>
                    Historical Performance
                  </h3>
                  <div className="flex items-center flex-col md:flex-row  md:space-x-2">
                    <div className="text-sm flex flex-col md:flex-row items-center md:space-x-2">
                      <p className="text-[#A6A6A6]">Caprock Growth: </p>
                      <p className="font-medium text-black">
                        {details.details.risk_profile}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Chart Section */}
                <div className="py-6 px-4 bg-white">
                  <div style={{ width: "100%", height: "400px" }}>
                    <Line data={dataLine} options={optionsLine} />
                  </div>
                </div>
                <div
                  className="pdf-only "
                  style={{
                    width: "800px",
                    height: "200px",
                  }}
                >
                  <Line
                    ref={historyChartRef}
                    data={dataLine}
                    options={optionsLine}
                  />
                </div>
                <span className="text-sm text-black  leading-relaxed">
                  <p className="font-bold">
                    *Past performance is not a guide to future performance.{" "}
                  </p>
                  <p className="font-medium">
                    {details.historic_performance_notes}
                  </p>
                </span>
              </div>
              <div className="lg:flex lg:space-x-6">
                {/* Disclaimer Section */}
                <div className="flex-[1.2] bg-[#F5FBFF] p-4 rounded-lg shadow-md border border-gray-300">
                  <div className="flex items-center border-b pb-2 justify-between mb-4">
                    <h3 className="text-md font-medium text-black flex items-center">
                      <span className="mr-2">
                        <img
                          src="/info-circle.svg"
                          alt="Portfolio Icon"
                          className="w-5 h-5"
                        />
                      </span>
                      Disclaimer
                    </h3>
                  </div>
                  <p className="text-sm font-medium border-b pb-2 text-black leading-relaxed mb-4">
                    {details.disclaimer}
                  </p>
                  <h4 className="text-md font-medium text-black">Copyright</h4>
                  <p className="text-sm text-black font-medium leading-relaxed">
                    {details.copy_rights}
                  </p>
                </div>

                {/* Documents Section */}
                <div className="flex-[1] bg-white h-60 p-4 md:mt-0 lg:mt-0 mt-4 rounded-lg shadow-md border border-gray-300">
                  <div className="flex items-center border-b pb-2 justify-between mb-4">
                    <h3 className="text-md font-medium text-black flex items-center">
                      <span className="mr-2">
                        <img
                          src="/note-2.svg"
                          alt="Portfolio Icon"
                          className="w-5 h-5"
                        />
                      </span>
                      Documents
                    </h3>
                  </div>
                  <ul className="space-y-3 text-sm">
                    {details.documents.map((item, index) => (
                      <li className="flex flex-col border-b pb-2 sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
                        <p className="text-black font-medium text-sm sm:flex-1 break-words">
                          {item.name}
                        </p>
                        <button className="text-labelColour self-start sm:self-start font-medium text-sm underline flex items-center sm:mt-0 sm:ml-4">
                          <img
                            src="/document-download-grey.svg"
                            alt="Portfolio Icon"
                            className="w-4 h-4 mr-1"
                          />
                          Download
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="flex flex-col md:flex-row items-center rounded-lg shadow-lg mt-6 p-4 bg-white">
                {/* Left Section: Back Button */}
                <div className="flex items-center justify-start w-full md:w-1/2 mb-4 md:mb-0">
                  <div
                    onClick={() => {
                      let redirectState = {
                        path: "/investment-hub",
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      };
                      sessionStorage.setItem(
                        "redirectAfterLogin",
                        JSON.stringify(redirectState)
                      );
                      navigate("/investment-hub");
                    }}
                    className="flex items-center space-x-2 text-sm border-2 border-black rounded-full md:text-md font-medium py-1 px-6 text-black cursor-pointer hover:bg-gray-100"
                  >
                    {/* Image on the left */}
                    <img
                      src="/bottom-back.svg" // Path to your image
                      alt="Back Icon"
                      className="w-4 h-4"
                    />
                    <span className="font-medium">Back</span>
                  </div>
                </div>
                <div className="flex items-center justify-end w-full md:w-1/2 mb-4 md:mb-0">
                  {/* <div
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      downloadPDF(e);
                    }}
                    className="flex items-center space-x-2 text-sm border-2 border-black rounded-full md:text-md font-medium py-1 px-6 text-black cursor-pointer hover:bg-gray-100"
                  >
                    <span className="font-medium">Download</span>
                  </div> */}
                  <DownloadReportButton
                    onContinue={handleContinue}
                    onExcel={handleExcel}
                    buttonText="Download Factsheet"
                    confirmTitle="Download Factsheet"
                    confirmMessage="You can download the report in PDF or Excel format."
                  />
                </div>
              </div>
            </div>
          )}
          {filter == "invest" && (
            <div>
              <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 border-gray-200 space-y-6">
                {/* Header */}
                <div className="flex items-center border-b pb-2 space-x-2">
                  <img
                    src="/monitor-mobbile.svg"
                    alt="Portfolio Icon"
                    className="w-6 h-6"
                  />

                  <h2 className="text-lg font-medium text-black">
                    Electronic Execution
                  </h2>
                </div>

                {/* Content Section */}
                <div className="space-y-4 text-black border-b pb-4 font-medium">
                  <p className="text-sm">
                    A party may sign electronically a soft copy of this document
                    and any future amendments or variations of this document
                    through the digital
                    <span className="font-medium">
                      {" "}
                      'click' acceptance{" "}
                    </span>{" "}
                    via the Platform or by signing this document by some other
                    electronic method (including signing by stylus or pasting of
                    the signatory's signature) and bind itself accordingly. This
                    will satisfy any statutory or other requirements for this
                    document to be in writing and signed by that party.
                  </p>

                  {/* List */}
                  <ul className="list-disc pl-6 space-y-2">
                    <li className="text-sm">
                      Any soft copy so signed will constitute an executed
                      original counterpart, and any print-out of the copy with
                      the relevant signatures appearing will also constitute an
                      executed original counterpart; and
                    </li>
                    <li className="text-sm">
                      Where a party prints out this document after all parties
                      that are signing electronically have done so, the first
                      print-out by that party after all signatories who are
                      signing through DocuSign digital
                      <span className="font-medium">
                        {" "}
                        'click' acceptance{" "}
                      </span>{" "}
                      via the Platform or other electronic execution method or
                      signature will also be an executed original counterpart of
                      this document. Each signatory confirms that their
                      signature appearing in the agreement, including any such
                      print-out (irrespective of which party printed it), is
                      their personal signature authenticating it.
                    </li>
                  </ul>
                </div>

                {/* Executed as Agreement Section */}
                <div className="space-y-4 text-black font-medium">
                  <div className="flex items-center space-x-2">
                    <img
                      src="/verify.svg"
                      alt="Portfolio Icon"
                      className="w-6 h-6"
                    />

                    <h2 className="text-lg font-medium text-black">
                      Executed as an Agreement
                    </h2>
                  </div>{" "}
                  <ul className="list-disc pl-6 space-y-2">
                    <li className="text-sm">
                      By signing or accepting below, each director or secretary
                      (as applicable) acknowledges and accepts the terms and
                      conditions in the Agreement.
                    </li>
                    <li className="text-sm">
                      By signing or accepting below, each director or secretary
                      (as applicable) consents to electronic execution of this
                      document (in whole or in part), represents that they hold
                      the position or are the person named with respect to their
                      execution, and authorizes any other director or secretary
                      (as applicable) to produce a copy of this document bearing
                      his or her signature for the purpose of signing the copy
                      to complete its execution under section 127 of the
                      Corporations Act. The copy of the signature appearing on
                      the copy so executed is to be treated as his or her
                      original signature.
                    </li>
                  </ul>
                </div>
                <div className="flex items-center space-x-2 mt-4">
                  <input
                    type="checkbox"
                    id="confirm-all"
                    className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                    checked={isCheckedSecond}
                    onChange={(e) => setIsCheckedSecond(e.target.checked)}
                  />
                  <label
                    htmlFor="confirm-all"
                    className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                  >
                    Yes, I Confirm.
                  </label>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 border-gray-200 space-y-6">
                {/* Header */}
                <div className="flex items-center border-b pb-2 space-x-2">
                  <img
                    src="/book-mark.svg"
                    alt="Portfolio Icon"
                    className="w-6 h-6"
                  />

                  <h2 className="text-lg font-medium text-black">
                    Terms & Conditions
                  </h2>
                </div>

                {/* Content Section */}
                <div className="space-y-4 text-black border-b pb-4 font-medium">
                  <p className="text-sm text-labelLightColour">Execution</p>
                  <p className="text-sm">
                    Execution of the chosen investment strategy will be done on
                    a best endeavours basis.{" "}
                  </p>
                  <p className="text-sm">
                    The cut-off times in relation to these instructions will be
                    as follows:
                  </p>
                  {/* List */}
                  <ul className="list-disc pl-6 space-y-2">
                    <li className="text-sm">
                      Any soft copy so signed will constitute an executed
                      original counterpart, and any print-out of the copy with
                      the relevant signatures appearing will also constitute an
                      executed original counterpart; and
                    </li>
                    <li className="text-sm">
                      Where a party prints out this document after all parties
                      that are signing electronically have done so, the first
                      print-out by that party after all signatories who are
                      signing through DocuSign digital
                      <span className="font-medium">
                        {" "}
                        'click' acceptance{" "}
                      </span>{" "}
                      via the Platform or other electronic execution method or
                      signature will also be an executed original counterpart of
                      this document. Each signatory confirms that their
                      signature appearing in the agreement, including any such
                      print-out (irrespective of which party printed it), is
                      their personal signature authenticating it.
                    </li>
                  </ul>
                </div>
                <div className="space-y-4 text-black pb-4 font-medium">
                  <p className="text-sm text-labelLightColour">
                    Transaction Costs
                  </p>
                  <p className="text-sm">
                    Execution of the chosen investment strategy will be done on
                    a best endeavours basis.{" "}
                  </p>
                  <p className="text-sm">
                    The cut-off times in relation to these instructions will be
                    as follows:
                  </p>
                  {/* List */}
                  <ul className="list-disc pl-6 space-y-2">
                    <li className="text-sm">
                      Any soft copy so signed will constitute an executed
                      original counterpart, and any print-out of the copy with
                      the relevant signatures appearing will also constitute an
                      executed original counterpart; and
                    </li>
                    <li className="text-sm">
                      Where a party prints out this document after all parties
                      that are signing electronically have done so, the first
                      print-out by that party after all signatories who are
                      signing through DocuSign digital
                      <span className="font-medium">
                        {" "}
                        'click' acceptance{" "}
                      </span>{" "}
                      via the Platform or other electronic execution method or
                      signature will also be an executed original counterpart of
                      this document. Each signatory confirms that their
                      signature appearing in the agreement, including any such
                      print-out (irrespective of which party printed it), is
                      their personal signature authenticating it.
                    </li>
                  </ul>
                </div>
              </div>
              {(Number(amount) <= 0 ||
                isChecked == false ||
                clientAccountId == null) && (
                <div className="bg-[#FFF5F5] border border-[#FF5050] font-medium text-black text-md  px-4 py-4 mt-4 flex items-center justify-center">
                  <img
                    src="/danger.svg"
                    alt="Portfolio Icon"
                    className="w-5 h-5 mr-2"
                  />
                  Please fill all the fields
                </div>
              )}
              <div
                className={`bg-white p-6  shadow-lg border border-t-0 border
          ${
            Number(amount) <= 0 || isChecked == false || clientAccountId == null
              ? "border-[#FF5050]"
              : "mt-4"
          }
          `}
              >
                {/* Form Header */}
                <div className="flex font-medium justify-between items-center border-b border-gray-200 pb-4">
                  <div className="flex items-center">
                    <img
                      src="/personalcard.svg"
                      alt="Icon"
                      className="w-6 h-6 mr-2"
                    />
                    <h2 className="text-lg font-medium text-black">
                      Investment Application
                    </h2>
                  </div>
                  <div className="flex items-center">
                    <p className="text-sm text-labelLightColour mr-2">Date:</p>
                    <p className="text-sm  text-black">
                      {" "}
                      {new Date().toLocaleDateString("en-GB")}
                    </p>
                  </div>
                </div>

                {/* Form Fields */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
                  {/* Name */}
                  <div className="col-span-1 w-full pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-sm text-labelLightColour">
                      Name
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.invest_application.name}
                      </p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-span-1 w-full pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-sm text-labelLightColour">
                      Email
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.invest_application.email}
                      </p>
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-span-1 w-full pt-4 pl-4 pb-4 border-b md:border-r">
                    <label className="text-sm text-labelLightColour">
                      Mobile Number
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.invest_application.mobile_number}
                      </p>
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-span-1 w-full pt-4 pl-4 pb-4 border-b">
                    <label className="text-sm text-labelLightColour">
                      Date of Birth
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {details.invest_application.date_of_birth}
                      </p>
                    </div>
                  </div>

                  {/* Investment Amount */}
                  <div className="col-span-1  pt-4 pl-4 pb-4 pr-4 md:border-r">
                    <label className="text-sm  text-labelLightColour">
                      Amount you would like to invest
                    </label>
                    <input
                      id="amount"
                      type="text"
                      value={isFocused ? amount : formatNumber(amount)}
                      ref={inputRef}
                      onChange={(e) => {
                        // Avoid triggering onChange if the focus is on the button
                        if (!isFocused) return;

                        handleAmountChange(e, e.target.value);
                      }}
                      onFocus={() => setIsFocused(true)}
                      onBlur={(e) => {
                        setIsFocused(false);
                      }}
                      className="text-sm mt-2 w-full p-2 text-black border rounded-md text-md"
                      placeholder="$0"
                    />
                  </div>
                  <div className="col-span-1 w-full pt-4 pl-4 pb-4 pr-4 md:border-r">
                    <Dropdown
                      label="Select Account"
                      options={newClientAccountData}
                      preselectedValue={preSelectedClientAccount}
                      onSelect={handleSelectClientAccount}
                      colorLabel="text-labelLightColour"
                    />
                  </div>
                  <div className="col-span-1  md:col-span-2 pt-4 pl-4 pb-4 pr-4 md:border-r">
                    <label className="text-sm font-medium text-labelLightColour">
                      Account Balance
                    </label>
                    <div className="rounded-md py-1">
                      <p className="text-black text-sm font-medium">
                        {" "}
                        $
                        {clientAccountBalance
                          ? clientAccountBalance
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </p>
                    </div>
                  </div>

                  {/* Confirmation */}
                  <div className="col-span-1 md:col-span-4 pt-4 pl-4 pb-4">
                    <div className="flex items-center space-x-2">
                      <label
                        htmlFor="confirm"
                        className="text-sm text-black block w-full break-words whitespace-normal leading-tight"
                      >
                        I confirm I have read the Information Memorandum and
                        agree to the Terms & Conditions
                      </label>
                    </div>

                    <div className="flex items-center space-x-2 mt-4">
                      <input
                        type="checkbox"
                        id="confirm-yes"
                        className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <label
                        htmlFor="confirm-yes"
                        className={`text-sm
                      ${isChecked ? "text-black" : "text-[#888888]"}
                      `}
                      >
                        Yes, I Confirm.
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {isRestricted && (
                <RestrictedAccountAlert className="mt-4 md:hidden" />
              )}

              <div className="flex flex-col md:flex-row items-center rounded-lg shadow-lg mt-6 p-4 bg-white">
                {/* Left Section: Back Button */}
                <div className="flex items-center justify-start w-full md:w-1/2 mb-4 md:mb-0">
                  <div
                    onClick={() => {
                      let redirectState = {
                        path: "/investment-hub",
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      };
                      sessionStorage.setItem(
                        "redirectAfterLogin",
                        JSON.stringify(redirectState)
                      );
                      navigate("/investment-hub");
                    }}
                    className="flex items-center space-x-2 text-sm border-2 border-black rounded-full md:text-md font-medium py-1 px-6 text-black cursor-pointer hover:bg-gray-100"
                  >
                    {/* Image on the left */}
                    <img
                      src="/bottom-back.svg" // Path to your image
                      alt="Back Icon"
                      className="w-4 h-4"
                    />
                    <span className="font-medium">Back</span>
                  </div>
                </div>

                {/* Right Section: Download Button */}
                <div className="flex flex-col items-end w-full md:w-1/2 space-y-4">
                  <RestrictedAccountAlert className="hidden md:block w-full max-w-md" />
                  {/* Invest Now Button */}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (blockIfRestricted()) {
                        return;
                      }
                      if (Number(amount) <= 0) {
                        showToast("Please Enter Valid Amount", "error"); // Success toast
                        return;
                      }
                      if (clientAccountId == null) {
                        showToast("Please Select Account", "error"); // Success toast
                        return;
                      }
                      if (isChecked == false) {
                        showToast(
                          "Please confirm terms and conditions",
                          "error"
                        ); // Success toast
                        return;
                      }
                      if (isCheckedSecond == false) {
                        showToast(
                          "Please confirm Electronic Execution and agreement form",
                          "error"
                        ); // Success toast
                        return;
                      }
                      setLoading(true);
                      handleCreateInvestment(e);
                    }}
                    disabled={isRestricted || loading}
                    className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 border-2 rounded-full text-sm hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CashAccountInvestmentDetails;
